import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import {Checkbox} from "@material-ui/core";

// This method is needed for rendering clones of draggables
export const getRenderItem = (items, className) => (provided, snapshot, rubric) => {
    const item = items[rubric.source.index];
    return (
        <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            style={provided.draggableProps.style}
            className={snapshot.isDragging ? "dragging" : ""}
        >
            <Divider/>
            <ListItem
                dense
                disableGutters
            >
                <Checkbox
                    size={"small"}
                    style={{padding: 0, marginRight: 5}}
                    color={"primary"}
                />
                <ListItemText primary={item.label}/>
            </ListItem>
            <Divider/>
        </div>
    );
};